import * as Sentry from "@sentry/nextjs";
import Router from 'next/router'


export const checkPrices = (products: Array<any>, area: string) => {
  let errorOccured = false;

  if (products.length == 0) {
    return;
  }
  const totalProductsLength = products.length;
  const filteredProducts = products.filter((variant) => { return variant.hasOwnProperty('default_price') && variant.default_price > 0 });
  const filteredProductsLength = filteredProducts.length;
  if (filteredProductsLength == 0) {
    Sentry.captureMessage('[PRICE-01] [Store/Games] Unticked pricing checkbox on BC - All products $0 - ' + area, "fatal");
    errorOccured = true;
  } else if (filteredProductsLength < totalProductsLength) {
    Sentry.captureMessage('[PRICE-02] [Store/Games] Return of wrong price data - Intermittent $0 - ' + area, "error");
    errorOccured = true;
  } else {
    // all good
  }

  if (errorOccured) {
    Router.push('/maintenance');
  }
}
